/*
saikrishna 10/04/2022 2698403495 Fixed client maintenance and role management bugs JIra(229,232,33,34,49,56,58,393,94,95)
saikrishna 10/07/2022 2700539021 fixed expiry bug change password
ashraf 10/10/2022 2700539021 removed commented code
ashraf 10/13/2022 2700539021 fixed user expiry access bug
ashraf 10/14/2022 2700539021 fixed sidebar issue caused by role management
*/


import React, {useContext} from 'react';
import AppContext from '../../../contextProvider/AppContextProvider/AppContext';
import CmtVerticalLayout from '../../../../@coremat/CmtLayouts/Vertical';
import CmtSidebar from '../../../../@coremat/CmtLayouts/Vertical/Sidebar';
import SideBar from '../../partials/SideBar';
import CmtContent from '../../../../@coremat/CmtLayouts/Vertical/Content';
import ContentLoader from '../../../ContentLoader';
import {SIDEBAR_TYPE} from '../../../../constants/ThemeOptions';
import clsx from 'clsx';
import SidebarHeader from '../../partials/SidebarHeader';
import {useSelector} from 'react-redux';

const VerticalMinimal = ({className, children}) => {
  const {roleData} = useSelector(({role}) => role);

  const {drawerBreakPoint, isSidebarFixed, sidebarStyle, sidebarSize} = useContext(AppContext);
  return (
    <CmtVerticalLayout
      drawerBreakPoint={drawerBreakPoint}
      sidebarWidth={sidebarSize}
      className={clsx('verticalMinimalLayout', className)}
    >
      {roleData?.userDetails?.userId && roleData?.userDetails?.userName && 
      roleData?.userDetails?.role && <CmtSidebar type={SIDEBAR_TYPE.MINI} isSidebarFixed={isSidebarFixed} {...sidebarStyle}>
        <SidebarHeader />
        <SideBar />
      </CmtSidebar>}
      <CmtContent className="pl-0">
        {children}
        <ContentLoader />
      </CmtContent>
    </CmtVerticalLayout>
  );
};

export default VerticalMinimal;
